import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createVNode as _createVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "first_name"
}, "Nombre *", -1)
const _hoisted_5 = { class: "control" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_7 = { class: "column" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "last_name"
}, "Apellido *", -1)
const _hoisted_10 = { class: "control" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "personal_identification"
}, "Cédula *", -1)
const _hoisted_15 = { class: "control" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "age"
}, "Edad", -1)
const _hoisted_20 = { class: "control" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo con fines estadisticos ", -1)
const _hoisted_22 = { class: "columns" }
const _hoisted_23 = { class: "column" }
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "email"
}, "Correo *", -1)
const _hoisted_26 = { class: "control" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_28 = { class: "column" }
const _hoisted_29 = { class: "field" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: " tel"
}, "Número de telefono *", -1)
const _hoisted_31 = { class: "control" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_33 = { class: "column" }
const _hoisted_34 = { class: "field" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "disabled"
}, "Tiene discapacidad ?", -1)
const _hoisted_36 = { class: "select is-link is-fullwidth" }
const _hoisted_37 = ["value"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo con fines estadisticos ", -1)
const _hoisted_39 = { class: "column" }
const _hoisted_40 = { class: "field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "province"
}, "Grupo étnico", -1)
const _hoisted_42 = { class: "control" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo con fines estadisticos ", -1)
const _hoisted_44 = { class: "columns" }
const _hoisted_45 = { class: "column" }
const _hoisted_46 = { class: "field" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "province"
}, "Provincia *", -1)
const _hoisted_48 = { class: "control" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_50 = { class: "column" }
const _hoisted_51 = { class: "field" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "district"
}, "Distrito *", -1)
const _hoisted_53 = { class: "control" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_55 = { class: "column" }
const _hoisted_56 = { class: "field" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "township"
}, "Corregimiento *", -1)
const _hoisted_58 = { class: "control" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_60 = { class: "column" }
const _hoisted_61 = { class: "field" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "urbanization"
}, "Urbanización *", -1)
const _hoisted_63 = { class: "control" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo obligatorio según la Ley 6 de 22 de enero de 2002 ", -1)
const _hoisted_65 = { class: "field" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "gender"
}, "Genero", -1)
const _hoisted_67 = { class: "control" }
const _hoisted_68 = ["value"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "citizen-form__input-caption" }, " Campo con fines estadisticos ", -1)
const _hoisted_70 = { class: "columns" }
const _hoisted_71 = { class: "column" }
const _hoisted_72 = { class: "field" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "password"
}, "Contraseña", -1)
const _hoisted_74 = { class: "control" }
const _hoisted_75 = { class: "column" }
const _hoisted_76 = { class: "field" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "password_confirmation"
}, "Confirmación de contraseña", -1)
const _hoisted_78 = { class: "control" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("hr", { class: "block" }, null, -1)
const _hoisted_80 = { class: "columns" }
const _hoisted_81 = { class: "column" }
const _hoisted_82 = { class: "checkbox block" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" He leido y acepto todos los ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" impuestos. ")
const _hoisted_85 = /*#__PURE__*/_createStaticVNode("<div class=\"divider is-vertical\"> importante </div><div class=\"column\"><div id=\"recaptcha-notice\"><p class=\"content\"> Este sitio esta protegido por reCaptcha y la <a href=\"https://policies.google.com/privacy\" class>Política de Privacidad</a> y <a href=\"https://policies.google.com/terms\">Condiciones del servicio</a> de Google aplican. </p></div></div>", 2)
const _hoisted_87 = { class: "field is-grouped" }
const _hoisted_88 = { class: "control" }
const _hoisted_89 = { class: "is-svg icon is-small" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" Registrarme ")

import { reactive, ref, onMounted, watch } from "vue";
import { mdiAccountPlus } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import { RoleId } from "@/entities";
import { PartialUser } from "@/entities/user";
import { testEmail } from "@/utils";
import TermAndConditionModal from "@/components/common/TermAndConditionModal.vue";
import vSelect from "vue-select";
import PagedAsyncIterDriver from "@/pagination/paged-async-iter-driver";
import {
  territorialDivisionService,
  ethnicGroupService,
  genderService,
} from "@/services/index";
import Provinces from "@/entities/territorial-division/provinces";
import Districts from "@/entities/territorial-division/districts";
import Townships from "@/entities/territorial-division/townships";
import EthnicGroup from "@/entities/ethinc-groups";
import { vSelectBulmaDecorator } from "@/components/common/v-select";
import Gender from "@/entities/gender";
type Input<T> = { value: T; error: string };
export interface UserCreateEvent extends PartialUser {
  password: string;
  passwordConfirmation: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
  loadingButton: {
    required: true,
    type: Boolean,
  },
},
  emits: ["userCreate", "failure"],
  setup(__props, { emit }) {

const props = __props

/* eslint-disable @typescript-eslint/no-unused-vars,  @typescript-eslint/ban-types */



const userFields = reactive({
  firstNameInput: { value: "", error: "" } as Input<string>,
  lastNameInput: { value: "", error: "" } as Input<string>,
  emailInput: { value: "", error: "" } as Input<string>,
  ageInput: { value: "", error: "" } as Input<string>,
  genderInput: { value: 0, error: "" } as Input<number|null>,
  personalIdentificationInput: { value: "", error: "" } as Input<string>,
  provinceInput: { value: "", error: "" } as Input<string>,
  districtInput: { value: "", error: "" } as Input<string>,
  townshipInput: { value: "", error: "" } as Input<string>,
  urbanizationInput: { value: "", error: "" } as Input<string>,
  phoneNumberInput: { value: "", error: "" } as Input<string>,
  passwordInput: { value: "", error: "" } as Input<string>,
  passwordConfirmationInput: { value: "", error: "" } as Input<string>,
  
  userHaveDisability: [
    { value: 0, text: "No" },
    { value: 1, text: "Si" },
    { text: 'N/A'}
  ],
  haveDisabilityInput: { value: 0, error: "" } as Input<number>,
  ethnicGroupInput: { value: 0, error: "" } as Input<number>,
});
const isActive = ref(false);
const termAndConditionAccepted = ref(false);
const provinces = ref([] as Provinces[]);
const districts = ref([] as Districts[]);
const townships = ref([] as Townships[]);
const isDistrictDisabled = ref(true);
const isTownshipDisabled = ref(true);

const ethnicGroups = ref([] as EthnicGroup[]);
const genders = ref<Array<Partial<Gender> & Pick<Gender, 'id'>>>([]);

const onCreateClick = () => {
  if (validate()) {
    // this values always will be static
    const roleId = RoleId.Citizen;
    const enabled = true;
    const event: UserCreateEvent = {
      firstName: userFields.firstNameInput.value,
      lastName: userFields.lastNameInput.value,
      email: userFields.emailInput.value,
      password: userFields.passwordInput.value,
      entityId: null, // will be always null 'cause the user type
      passwordConfirmation: userFields.passwordConfirmationInput.value,
      age: userFields.ageInput.value,
      personal_identification: userFields.personalIdentificationInput.value,
      //province: userFields.provinceInput.value,
      //district: userFields.districtInput.value,
      township_id: userFields.townshipInput.value,
      urbanization: userFields.urbanizationInput.value,
      phone_number: userFields.phoneNumberInput.value,
      have_disability: userFields.haveDisabilityInput.value,
      roleId,
      enabled,
    };

    if (userFields.ethnicGroupInput.value != 0) {
      event.ethnic_group_id = userFields.ethnicGroupInput.value;
    }

    if (userFields.genderInput.value == 0) {
      event.gender_id = userFields.genderInput.value;
    }
    emit("userCreate", event);
  }
};

const validate = (): boolean => {
  let hasError = false;

  if (!termAndConditionAccepted.value) {
    hasError = true;
  }

  if (userFields.firstNameInput.value == "") {
    userFields.firstNameInput.error = "El campo de primer nombre esta vacio.";
    hasError = true;
  } else {
    userFields.firstNameInput.error = "";
  }

  if (userFields.lastNameInput.value == "") {
    userFields.lastNameInput.error = "El campo de apellido esta vacio.";
    hasError = true;
  } else {
    userFields.lastNameInput.error = "";
  }

  if (
    userFields.urbanizationInput.value == "" ||
    userFields.urbanizationInput.value == null
  ) {
    userFields.urbanizationInput.error =
      "El campo de urbanizacion esta vacio.";
    hasError = true;
  } else {
    userFields.urbanizationInput.error = "";
  }

  if (userFields.personalIdentificationInput.value == "") {
    userFields.personalIdentificationInput.error =
      "No se ha seleccionado la cedula del usuario.";
    hasError = true;
  } else {
    userFields.personalIdentificationInput.error = "";
  }

  if (
    userFields.provinceInput.value == "" ||
    userFields.provinceInput.value == null
  ) {
    userFields.provinceInput.error =
      "No se ha seleccionado la provincia del usuario.";
    hasError = true;
  } else {
    userFields.provinceInput.error = "";
  }

  if (
    userFields.districtInput.value == "" ||
    userFields.districtInput.value == null
  ) {
    userFields.districtInput.error =
      "No se ha seleccionado el distrito donde reside del usuario.";
    hasError = true;
  } else {
    userFields.districtInput.error = "";
  }

  if (
    userFields.townshipInput.value == "" ||
    userFields.townshipInput.value == null
  ) {
    userFields.townshipInput.error =
      "No se ha seleccionado el corregimiento del usuario.";
    hasError = true;
  } else {
    userFields.townshipInput.error = "";
  }

  if (userFields.phoneNumberInput.value == "") {
    userFields.phoneNumberInput.error =
      "No se ha escrito el numero de telefono del usuario.";
    hasError = true;
  } else {
    userFields.phoneNumberInput.error = "";
  }

  if (!testEmail(userFields.emailInput.value)) {
    userFields.emailInput.error = "El campo de correo no es valido.";
    hasError = true;
  } else {
    userFields.emailInput.error = "";
  }

  if (userFields.passwordInput.value != "") {
    if (userFields.passwordInput.value.length < 8) {
      userFields.passwordInput.error = "La contraseña es muy corta.";
      hasError = true;
    } else {
      userFields.passwordInput.error = "";
    }
    if (
      userFields.passwordConfirmationInput.value !=
      userFields.passwordInput.value
    ) {
      userFields.passwordConfirmationInput.error =
        "La confirmacion no coincide con la contraseña.";
      hasError = true;
    } else {
      userFields.passwordConfirmationInput.error = "";
    }
  }
  if (hasError) {
    emitFailures();
  }
  return !hasError;
};

const emitFailures = () => {
  const failuresArr: Array<[string, string[]]> = Object.entries({
    Nombre: userFields.firstNameInput,
    Apellido: userFields.lastNameInput,
    Edad: userFields.ageInput,
    Genero: userFields.genderInput,
    Email: userFields.emailInput,
    Contraseña: userFields.passwordInput,
    "Confirmación de contraseña": userFields.passwordConfirmationInput,
    Provincia: userFields.provinceInput,
    Distrito: userFields.districtInput,
    Corregimiento: userFields.townshipInput,
    Urbanizacion: userFields.urbanizationInput,
    "Terminos y condiciones": {
      error: termAndConditionAccepted.value
        ? ""
        : "No has aceptado los terminos y condiciones",
    },
  })
    .filter(([, val]) => val.error !== "")
    .map(([key, val]) => [key, [val.error]]);
  const failures = new Map<string, string[]>(failuresArr);

  emit("failure", failures);
};

const closeModal = () => {
  isActive.value = !isActive.value;
};
const openModal = () => {
  isActive.value = !isActive.value;
};

/**
 * Province watch -nested with district and township watch
 */
watch(
  () => userFields.provinceInput.value,
  (value, prevValue) => {
    if (value != prevValue && value != null) {
      getDistricts(value);
      userFields.townshipInput.value = "";
      userFields.districtInput.value = "";
      isDistrictDisabled.value = false;
      isTownshipDisabled.value = true;
    }

    if (value == null) {
      isTownshipDisabled.value = true;
      isDistrictDisabled.value = true;
      userFields.townshipInput.value = "";
      userFields.districtInput.value = "";
    }
  }
);

/**
 * District watch
 */
watch(
  () => userFields.districtInput.value,
  (value, prevValue) => {
    if (value != prevValue && value != null && value != "") {
      getTownships(value);
      userFields.townshipInput.value = "";
      isTownshipDisabled.value = false;
    }

    if (value == null) {
      userFields.townshipInput.value = "";
      isTownshipDisabled.value = true;
    }
  }
);

/**
 *  Township watch
 */
watch(
  () => userFields.townshipInput.value,
  (value) => {
    if (value == null) {
      userFields.townshipInput.value = "";
    }
  }
);

const getDistricts = async (province_id: string) => {
  try {
    const data = await PagedAsyncIterDriver.fromAsyncIterable(
      territorialDivisionService.searchDistrictsAsync(parseInt(province_id))
    );
    districts.value = await data.fetchRemaining();
  } catch (e) {
    console.log(e);
  }
};
const getTownships = async (district_id: string) => {
  try {
    const data = await PagedAsyncIterDriver.fromAsyncIterable(
      territorialDivisionService.searchTownshipsAsync(parseInt(district_id))
    );
    townships.value = await data.fetchRemaining();
  } catch (e) {
    console.log(e);
  }
};

const getEthnicGroups = async () => {
  try {
    const data = await PagedAsyncIterDriver.fromAsyncIterable(
      ethnicGroupService.getAllEthnicGroups()
    );
    ethnicGroups.value = await data.fetchRemaining();
    ethnicGroups.value.push({name: 'N/A'});
  } catch (e) {
    console.log(e);
  }
};

const getGenders = async () => {
  genders.value = await genderService.getGenders();
  genders.value.push({name: 'N/A'});
}

onMounted(async () => {
  try {
    const data = await PagedAsyncIterDriver.fromAsyncIterable(
      territorialDivisionService.searchProvincesAsync()
    );
    provinces.value = await data.fetchRemaining();

    await Promise.all([getEthnicGroups(), getGenders()]);
  } catch (error) {
    console.log(error);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              name: "first_name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userFields).firstNameInput.value) = $event)),
              placeholder: "Nombre",
              required: ""
            }, null, 512), [
              [_vModelText, _unref(userFields).firstNameInput.value]
            ]),
            _hoisted_6
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              name: "last_name",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(userFields).lastNameInput.value) = $event)),
              placeholder: "Apellido",
              required: ""
            }, null, 512), [
              [_vModelText, _unref(userFields).lastNameInput.value]
            ]),
            _hoisted_11
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              name: "personal_identification",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userFields).personalIdentificationInput.value) = $event)),
              placeholder: "6-7423-2332",
              required: ""
            }, null, 512), [
              [_vModelText, _unref(userFields).personalIdentificationInput.value]
            ]),
            _hoisted_16
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "number",
              name: "age",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(userFields).ageInput.value) = $event)),
              placeholder: "35"
            }, null, 512), [
              [_vModelText, _unref(userFields).ageInput.value]
            ]),
            _hoisted_21
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              name: "email",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(userFields).emailInput.value) = $event)),
              placeholder: "test@example.com",
              required: ""
            }, null, 512), [
              [_vModelText, _unref(userFields).emailInput.value]
            ]),
            _hoisted_27
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "tel",
              name: "tel",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(userFields).phoneNumberInput.value) = $event)),
              placeholder: "6928-2752",
              required: ""
            }, null, 512), [
              [_vModelText, _unref(userFields).phoneNumberInput.value]
            ]),
            _hoisted_32
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(userFields).haveDisabilityInput.value) = $event)),
              name: "disabled"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userFields).userHaveDisability, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.value,
                  value: option.value
                }, _toDisplayString(option.text), 9, _hoisted_37))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(userFields).haveDisabilityInput.value]
            ]),
            _hoisted_38
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", null, [
              _createVNode(_unref(vSelectBulmaDecorator), { "dropdown-classes": ['is-link'] }, {
                default: _withCtx(() => [
                  _createVNode(_unref(vSelect), {
                    modelValue: _unref(userFields).ethnicGroupInput.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(userFields).ethnicGroupInput.value) = $event)),
                    options: ethnicGroups.value,
                    reduce: (name) => name.id,
                    label: "name"
                  }, null, 8, ["modelValue", "options", "reduce"])
                ]),
                _: 1
              }),
              _hoisted_43
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", null, [
              _createVNode(_unref(vSelectBulmaDecorator), { "dropdown-classes": ['is-link'] }, {
                default: _withCtx(() => [
                  _createVNode(_unref(vSelect), {
                    modelValue: _unref(userFields).provinceInput.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(userFields).provinceInput.value) = $event)),
                    options: provinces.value,
                    reduce: (name) => name.id,
                    label: "name"
                  }, null, 8, ["modelValue", "options", "reduce"])
                ]),
                _: 1
              }),
              _hoisted_49
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", null, [
              _createVNode(_unref(vSelectBulmaDecorator), { "dropdown-classes": ['is-link'] }, {
                default: _withCtx(() => [
                  _createVNode(_unref(vSelect), {
                    modelValue: _unref(userFields).districtInput.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(userFields).districtInput.value) = $event)),
                    options: districts.value,
                    reduce: (name) => name.id,
                    label: "name",
                    disabled: isDistrictDisabled.value
                  }, null, 8, ["modelValue", "options", "reduce", "disabled"])
                ]),
                _: 1
              }),
              _hoisted_54
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", null, [
              _createVNode(_unref(vSelectBulmaDecorator), { "dropdown-classes": ['is-link'] }, {
                default: _withCtx(() => [
                  _createVNode(_unref(vSelect), {
                    modelValue: _unref(userFields).townshipInput.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(userFields).townshipInput.value) = $event)),
                    options: townships.value,
                    reduce: (name) => name.id,
                    label: "name",
                    disabled: isTownshipDisabled.value
                  }, null, 8, ["modelValue", "options", "reduce", "disabled"])
                ]),
                _: 1
              }),
              _hoisted_59
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              required: "",
              name: "urbanization",
              placeholder: "Urb. Nueva Luz",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(userFields).urbanizationInput.value) = $event))
            }, null, 512), [
              [_vModelText, _unref(userFields).urbanizationInput.value]
            ]),
            _hoisted_64
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _hoisted_66,
      _createElementVNode("div", _hoisted_67, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(genders.value, (gender) => {
          return (_openBlock(), _createElementBlock("label", {
            key: gender.id,
            class: "radio"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(userFields).genderInput.value) = $event)),
              required: "",
              name: "enabled",
              value: gender.id
            }, null, 8, _hoisted_68), [
              [_vModelRadio, _unref(userFields).genderInput.value]
            ]),
            _createTextVNode(" " + _toDisplayString(gender.name), 1)
          ]))
        }), 128))
      ]),
      _hoisted_69
    ]),
    _createElementVNode("div", _hoisted_70, [
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              required: "",
              name: "password",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(userFields).passwordInput.value) = $event))
            }, null, 512), [
              [_vModelText, _unref(userFields).passwordInput.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              required: "",
              name: "password_confirmation",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(userFields).passwordConfirmationInput.value) = $event))
            }, null, 512), [
              [_vModelText, _unref(userFields).passwordConfirmationInput.value]
            ])
          ])
        ])
      ])
    ]),
    _hoisted_79,
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("label", _hoisted_82, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "checkbox",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((termAndConditionAccepted).value = $event))
          }, null, 512), [
            [_vModelCheckbox, termAndConditionAccepted.value]
          ]),
          _hoisted_83,
          _createElementVNode("a", {
            href: "#",
            onClick: openModal
          }, "terminos y condiciones"),
          _hoisted_84
        ])
      ]),
      _hoisted_85
    ]),
    _createVNode(TermAndConditionModal, {
      "is-active": isActive.value,
      onClose: closeModal
    }, null, 8, ["is-active"]),
    _createElementVNode("div", _hoisted_87, [
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("button", {
          class: _normalizeClass(["button is-link", [props.loadingButton ? 'is-loading' : '']]),
          onClick: onCreateClick
        }, [
          _createElementVNode("span", _hoisted_89, [
            _createVNode(_unref(SvgIcon), {
              type: "mdi",
              path: _unref(mdiAccountPlus)
            }, null, 8, ["path"])
          ]),
          _hoisted_90
        ], 2)
      ])
    ])
  ]))
}
}

})